import React, { Component } from 'react';
import { connect } from 'react-redux';
import GetError from '../Response/GetError.js'
import  {Segment, Icon, Button, Modal, Header}  from 'semantic-ui-react'
import { Link } from "react-router-dom"
import API from '../../../services/Api'


class ConnectedGetGroupArticle extends Component {

    constructor(props){
        super(props);

        this.state = {
            modalOpen: false,
            currentProduct : {},
            currentIdx : -1,
        };

    }


    componentWillMount() {
        API.getProducts().then(res => {
            var allProducts = res.data.products
            this.setState({
                allProducts
            })
        })

        window.scrollTo(0, 0)
    }

    deleteProduct = (productId , index) => {
        API.deleteProduct(productId).then(res => {
            var tabCopy = this.state.allProducts;
            tabCopy.splice(index, 1);
            this.setState({
                allProducts : tabCopy,
                modalOpen: false
            })
        });
    }

    handleOpen = (prod, idx) => this.setState({ modalOpen: true, currentProduct: prod, currentIdx: idx })

    handleClose = () => this.setState({ modalOpen: false })
        

    render() {
        
        // let divstyle = { 'wordWrap': 'break-word' }
        // if(this.state.error !== null){
            return (
                <div className="ui container">
                    
                    <Segment basic >
                        <Link to='/produits/addArticle'>
                            <Button  primary floated='right'>Créer</Button>
                        </Link>
                    </Segment>

                <div className="ui container">
                    <div className="ui center aligned container">
                    <br/>
                    <h1 className="ui header">Group Article Area</h1>
                    <h2 className="ui header">Get</h2>
                    <br/>
                    </div>
                    
                    <div className="ui divided three column grid">
                    
                        <div className="row">
                            <div className="column">
                            </div>
                            <div className="ui column segment" >
                                <div className="ui center aligned container" >
                                <Segment basic>
                                    {(this.state.allProducts || []).map((product, idx) => <Segment key={product.id}>{product.name}
                                    <Link to={`/produits/update/${product.id}`}>
                                        <Icon circular name='edit' color="teal" className="actionIcon" onClick={()=> {}} floated='right'/>
                                    </Link>
                                    <Icon circular name='trash alternate'  color='red' className="actionIcon" floated='right'  onClick={() => this.handleOpen(product, idx)} />
                                    </Segment>)}
                                </Segment>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal 
                    open={this.state.modalOpen}
                >
                    <Header icon='exclamation' content='Confirmation de suppression de produit' />
                    <Modal.Content>
                    <p>
                        Etes sur de vouloir supprimer {this.state.currentProduct.name}?
                    </p>
                    </Modal.Content>
                    <Modal.Actions>
                    <Button color='red' onClick={this.handleClose} >
                        <Icon name='remove' /> No
                    </Button>
                    <Button color='green' onClick={()=> this.deleteProduct(this.state.currentProduct.id, this.state.currentIdx)}>
                        <Icon name='checkmark' /> Yes
                    </Button>
                    </Modal.Actions>
                </Modal>
                </div>
            )
        }
    }

const GetGroupArticle = (ConnectedGetGroupArticle);
export default GetGroupArticle;



// WEBPACK FOOTER //
// ./src/components/Protected/Article/GetGroupArticle.jsx